import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { EquipmentBaseBus } from "./EquipmentBaseBus";

  export class v_InvoiceEquipmentBus extends EquipmentBaseBus
  {
      CID(): any {
          return this.equipmentId;
      }
      constructor(data: v_InvoiceEquipmentBus = null) {
          super(data);
          if (data != null) {
              this.creationDate = DateFunctions.getDate(data.creationDate);
              this.insertDt = DateFunctions.getDate(data.insertDt);
              this.updateDt = DateFunctions.getDate(data.updateDt);
          }
      }
      setId(id: any) {
          this.equipmentId = id;
      }
      setParentId(id: any) {
          this.invoiceId = id;
      }
      initialize(data: v_InvoiceEquipmentBus) {
          super.initialize(data);
          try {
              this.creationDate = DateFunctions.getDate(data.creationDate);
              this.insertDt = DateFunctions.getDate(data.insertDt);
              this.updateDt = DateFunctions.getDate(data.updateDt);
          }
          catch {

          }

      }
      setFromForm(data: v_InvoiceEquipmentBus) {
          super.setFromForm(data);
          let dateNow = DateFunctions.getDateNow();
          if (this.hasId) {
          }
          else {
              this.equipmentId = CommonFunctions.getGuid();
              this.creationDate = dateNow;
              this.insertDt = dateNow;
          }
          this.updateDt = dateNow;

      }
      setBeforeSave() {
          this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
          this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
      }
      invoiceEquipmentXREFId: any;
      manufacturerId: string;
      manufacturerTypeId: string;
      locationId: any;
      model: string;
      serialNumber: string;
      notes: string;
      isPrintable: boolean;
      invoiceId: string;
      isOnDispatchQuote: boolean;
      systemId: string;
      barcode: string;
      createdBy: string;
      creationDate: Date;
      insertUserId: any;
      insertDt: Date;
      updateUserId: any;
      updateDt: Date;
      manufacturerName: string;
      manufacturerTypeName: string;
      dummy: any;
      
  }
